import React from 'react'

export const PaymentInformation = (props:any) => {
    const {amount,payment_id} = props;
  return (
    <div className="col-sm-6 px-4">
    <table className="table table-striped border-0 mt-4">
      <tbody>
        <tr>
          <th scope="row">Amount:</th>
          <td>{amount}</td>
        </tr>
        <tr>
          <th scope="row">Payment Id:</th>
          <td>{payment_id}</td>
        </tr>
        </tbody>
      </table>
    </div>
  )
}
